import { Box, Theme, Typography, useTheme } from "@outschool/backpack";
import { Trans, useTranslation } from "@outschool/localization";
import { joinMembershipPath } from "@outschool/routes";
import { useSession } from "@outschool/ui-auth";
import { CreditIcon, TrackedButton } from "@outschool/ui-components-shared";
import { useIsEligibleFor40PercentCouponUpsell } from "@outschool/ui-components-website";
import { useIsMobile, useNavigation } from "@outschool/ui-utils";
import React from "react";
import { useLocation } from "react-router";

import { SubscriptionEsaDisableTooltip } from "./SubscriptionEsaDisableTooltip";

export function JoinSubscriptionNavItem() {
  const location = useLocation();
  const theme = useTheme();
  const navigate = useNavigation();
  const { isEsaSession } = useSession();
  const { t } = useTranslation(
    "client\\components\\nav\\JoinSubscriptionNavItem"
  );

  const { isEligibleFor40PercentCouponUpsell } =
    useIsEligibleFor40PercentCouponUpsell();

  const isMobile = useIsMobile();
  return (
    <Box
      sx={(theme: Theme) => ({
        ...(!isMobile && {
          "&:hover": {
            color: theme.palette.grey[900],
            boxShadow: `inset 0 -4px 0 ${theme.palette.grey[400]}`
          }
        })
      })}
    >
      <SubscriptionEsaDisableTooltip
        tooltipComponent={
          <Trans t={t}>
            Memberships aren’t available with state ESA, microgrant,
            scholarships or public funds. For additional information, contact{" "}
            <a href="mailto:support@outschool.com">support@outschool.com</a>.
          </Trans>
        }
      >
        <TrackedButton
          variant="link"
          trackingName="subscription_join_nav_item"
          data-test-id="subscription-join-nav-item"
          sx={{
            border: "none",
            paddingX: 8,
            paddingTop: 6,
            display: "block",
            color: "neutral.700",
            [theme.breakpoints.down("md")]: {
              display: "flex",
              padding: "16px"
            },
            [theme.breakpoints.down("sm")]: {
              paddingX: "8px"
            },
            textDecoration: "none !important"
          }}
          onClick={(_e: React.MouseEvent<HTMLButtonElement>) => {
            navigate(
              joinMembershipPath({ redirectAfterPath: location.pathname })
            );
          }}
        >
          {isMobile && !isEligibleFor40PercentCouponUpsell ? (
            <Typography variant="subtitle2">{t("Plans")}</Typography>
          ) : (
            <Box>
              <Box>
                <CreditIcon
                  fillColor={
                    isEsaSession
                      ? theme.palette.grey[300]
                      : theme.palette.warning.main
                  }
                  strokeColor={
                    isEsaSession
                      ? theme.palette.grey[700]
                      : theme.palette.warning[700]
                  }
                  sx={{ width: "2.4rem", height: "2.4rem" }}
                />
              </Box>
              <Typography
                variant="body2"
                sx={{
                  color: isEsaSession ? "grey.500" : theme.palette.common.black,
                  fontWeight: 500,
                  fontSize: "1.2rem"
                }}
              >
                {isEligibleFor40PercentCouponUpsell
                  ? t("Save up to 50%")
                  : t("Save up to 20%")}
              </Typography>
            </Box>
          )}
        </TrackedButton>
      </SubscriptionEsaDisableTooltip>
    </Box>
  );
}
